import { useFormikContext } from 'formik';
import React from 'react';
import { Supplier_supplier } from '../../../__generated__/Supplier';
import { SupplierAvailableDocumentTypes } from '../__generated__/SupplierAvailableDocumentTypes';
import { AttachFormModal } from './AttachFormModal';
interface AttachFormProps {
  availableDocumentTypes: SupplierAvailableDocumentTypes | undefined;
  supplier: Supplier_supplier;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  supplier,
  availableDocumentTypes,
}) => {
  const { dirty } = useFormikContext<any>();

  return (
    <AttachFormModal
      supplier={supplier}
      availableDocumentTypes={availableDocumentTypes}
      isDirty={dirty}
    />
  );
};
